module.exports = __webpack_public_path__ + "static/1-e4eff6bab7c19017ac3019753df62e9e.jpg";